import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useListMarktStocksQuery } from '../../../redux/api/marktApi';

const MarktStockOverview = () => {
  const { data: stocks, isLoading } = useListMarktStocksQuery();

  return isLoading ? (
    <p>Bestände werden geladen...</p>
  ) : stocks ? (
    <Fragment>
      <h4>Bestände Getränkemarkt</h4>
      <table className='table table-striped mt-4 align-middle text-start'>
        <thead>
          <tr>
            <th>Artikel</th>
            <th>Einheit</th>
            <th>Bestand</th>
            <th>Reserviert</th>
            <th>Verkäuflich</th>
          </tr>
        </thead>
        <tbody>
          {stocks.map((stock, index) => (
            <tr key={index}>
              <td>{stock.article_name}</td>
              <td>{stock.unit}</td>
              <td>{stock.quantity_available}</td>
              <td>{stock.quantity_reserved ?? 0}</td>
              <td>
                <strong>{stock.quantity_sellable ?? stock.quantity_available}</strong>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Fragment>
  ) : (
    <p>Keine Bestände gefunden.</p>
  );
};

export default MarktStockOverview;
